import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPersonOffFill = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M200-160q-17 0-28.5-11.5T160-200v-72q0-34 17.5-62.5T224-378q45-23 91.5-37t94.5-21L83-763q-12-12-11.5-28T84-819t28.5-12 28.5 12l679 679q12 12 12 28t-12 28-28.5 12T763-84l-77-76zm600-114L666-408q18 7 35.5 14t34.5 16q29 14 46 42.5t18 61.5M568-506 346-728q23-34 58-53t76-19q66 0 113 47t47 113q0 41-19 76t-53 58" })));
const ForwardRef = forwardRef(SvgPersonOffFill);
const Memo = memo(ForwardRef);
export default Memo;
